import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../../store/reducers';
import { getList } from '../../pages/ProjectDetails/Store';
import { getStoredAccessToken } from '../../helpers/authSession';
import {
	DEFAULT_BROWSER_TITLE,
	formatProjectBrowserTitle,
	getProjectIdFromLocationParts,
	getProjectNameFromSearch,
	normalizeProjectIdValue,
} from './projectTitle';

const ProjectTitleManager: FC = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const { list } = useSelector((state: RootState) => ({
		list: state.projectDetailsStore.list,
	}));
	const projectId = getProjectIdFromLocationParts(location.pathname, location.search);
	const queryProjectName = getProjectNameFromSearch(location.search);
	const listProjectId = normalizeProjectIdValue(list?.id);
	const listProjectName = projectId && listProjectId === projectId ? list?.name : '';
	const projectName = queryProjectName || listProjectName;

	useEffect(() => {
		document.title = formatProjectBrowserTitle(projectName);
	}, [projectName]);

	useEffect(() => {
		const appToken = getStoredAccessToken();
		if (!appToken || !projectId || projectName || listProjectId === projectId) return;

		dispatch(getList(projectId));
	}, [dispatch, listProjectId, projectId, projectName]);

	useEffect(
		() => () => {
			document.title = DEFAULT_BROWSER_TITLE;
		},
		[],
	);

	return null;
};

export default ProjectTitleManager;
